import { Theme } from '@eversports/react-components/design-tokens/theme'
import Flex from '@eversports/react-components/primitives/Flex'
import RadioButton from '@eversports/react-components/primitives/RadioButton'
import { TableRow } from '@eversports/react-components/primitives/Table'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { isPurchaseOptionPurchasable, PurchaseOption as PurchaseOptionType } from '../../typings/Product'

import ProductInformation from './ProductInformation'
import ProductPrice from './ProductPrice'
import ProductTableCell from './ProductTableCell'
import PurchaseOptionName from './PurchaseOptionName'

interface Props {
  product: PurchaseOptionType
}

const useStyles = makeStyles((theme: Theme) => ({
  row: ({ isDisabled }: { isDisabled: boolean }) => ({
    opacity: isDisabled ? 0.5 : 1,
    pointerEvents: isDisabled ? 'none' : 'auto',
    '&:hover': {
      backgroundColor: theme.palette.disabled,
    },
  }),
  radio: {
    paddingLeft: 0,
  },
}))

const PurchaseOption: React.FC<React.PropsWithChildren<Props>> = ({ product }) => {
  const isDisabled = !isPurchaseOptionPurchasable(product)
  const classes = useStyles({ isDisabled })

  return (
    <TableRow className={classes.row} data-testid="purchase-option-row">
      <ProductTableCell>
        <Flex is="label" alignItems="center">
          <RadioButton name="settleWithId" value={product.id} className={classes.radio} withLabelWrapper={false} />
          <PurchaseOptionName product={product} />
        </Flex>
      </ProductTableCell>
      <ProductTableCell align="center">
        <ProductInformation product={product} />
      </ProductTableCell>
      <ProductTableCell align="center">
        <ProductPrice product={product} />
      </ProductTableCell>
    </TableRow>
  )
}

export default PurchaseOption
